import { AnimatePresence, motion } from "framer-motion";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { deleteProspect, getProspects } from "../../../slices/prospectSlice";

export default function ModalDeleteProspect({
  setIsModalOpenDelete,
  isModalOpenDelete,
  prospect,
}) {
  const dispatch = useDispatch();

  const handleDeleteProspect = async (id) => {
    await dispatch(deleteProspect(id));
    await dispatch(getProspects());
    setIsModalOpenDelete(false);
  };

  return (
    <AnimatePresence>
      {isModalOpenDelete && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpenDelete(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-white rounded-xl shadow-2xl p-8 w-[400px] mx-4 border border-gray-100"
          >
            {/* Header */}
            <div className="flex justify-end">
              <button
                onClick={() => setIsModalOpenDelete(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <XMarkIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            {/* Contenido */}
            <div className="flex flex-col items-center space-y-6">
              {/* Ícono de eliminación */}
              <div className="p-4 bg-red-50 rounded-full">
                <TrashIcon className="w-10 h-10 text-red-500" />
              </div>

              {/* Título */}
              <h1 className="text-2xl font-bold text-gray-900 text-center">
                ¿Eliminar a{" "}
                {prospect.namePodcast
                  ? `${prospect.namePodcast}`
                  : "Sin Podcast"}
                ?
              </h1>

              {/* Descripción */}
              <p className="text-gray-500 text-center">
                Este podcast es de {prospect.name}
              </p>

              {/* Estado */}
              <p className="text-gray-700 text-center">
                Estado: {prospect.status}
              </p>
            </div>

            {/* Botones de acción */}
            <div className="mt-8 flex justify-center space-x-4">
              <button
                onClick={() => setIsModalOpenDelete(false)}
                className="px-6 py-2 text-sm font-medium text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={() => handleDeleteProspect(prospect._id)}
                className="px-6 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
              >
                Eliminar
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}